<template>
  <div class="q-pa-md">
    <main class="base">
      <header class="row headerBase">
        <img
          v-if="
            $store.state.autenticacao.logo &&
            $store.state.autenticacao.logo.logoImpressao
          "
          :src="$store.state.autenticacao.logo.logoImpressao"
          alt="Multpex Logo"
          class="multpex q-pl-sm"
        />
        <img
          v-else
          src="../../../assets/MULTPEX_VETOR.png"
          alt="Acciona Logo"
          class="multpex q-pl-sm"
        />

        <p class="text-h6 text-bold q-pa-md">
          {{ dadosFicha.titulo ? dadosFicha.titulo : "Título" }}
        </p>
      </header>
      <section class="separador"></section>
      <div class="data1">
        <p class="q-pl-sm text-bold">NOME: {{ nome }}</p>
      </div>
      <div class="row data2 align">
        <p class="q-pl-sm row align função text-bold">FUNÇÃO: {{ funcao }}</p>
        <p class="q-pl-sm row align registro text-bold">
          REGISTRO: {{ registro }}
        </p>
      </div>
      <section class="separador"></section>
      <div>
        <p class="row justify-center text-bold">
          {{ dadosFicha.subtitulo ? dadosFicha.subtitulo : "Subtítulo" }}
        </p>
      </div>
      <div class="data2 text-bold q-pl-sm">
        <p>
          {{ dadosFicha.dizeres ? dadosFicha.dizeres : "Dizeres" }}
        </p>
      </div>
      <div class="row data2 border-botom">
        <div class="column DESCRIÇÃODOMATERIAL borderleft">
          <p class="q-pa-md row justify-center text-bold">
            DESCRIÇÃO DO MATERIAL
          </p>
        </div>
        <div class="column ENTREGA borderleft">
          <p class="row justify-center border-botom text-bold">ENTREGA</p>
          <div class="row">
            <div class="table1 borderleft">
              <p class="text text-bold">Nº DO PATRIMONIO</p>
            </div>
            <div class="table3 borderleft">
              <p class="text text-bold">ASSINATURA</p>
            </div>
            <div class="table4 borderleft">
              <p class="text text-bold">DATA DA ENTREGA</p>
            </div>
            <div class="unidade-entrega">
              <p class="text text-bold">UNIDADE DE ENTREGA</p>
            </div>
          </div>
        </div>
        <div class="column DEVOLUÇÃO">
          <p class="row justify-center border-botom text-bold">DEVOLUÇÃO</p>
          <div class="row">
            <div class="secondTable2 borderleft">
              <p class="text text-bold">ASSINATURA</p>
            </div>
            <div class="secondTable3 borderleft">
              <p class="text text-bold">DATA DA ENTREGA</p>
            </div>
            <div class="unidade-devolucao">
              <p class="text text-bold">UNIDADE DE DEVOLUÇÃO</p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="data3 row border-botom"
        :class="{ quebra: quebras.indexOf(index) != -1 }"
        v-for="(tabela, index) in tabelas"
        :key="index"
      >
        <div class="DESCRIÇÃODOMATERIAL borderleft">
          <p style="width: 100%" class="row justify-center">
            {{ tabela.ferramenta_descricao }}
          </p>
        </div>
        <div class="ENTREGA borderleft">
          <div class="row" style="height: 100%">
            <div class="table1 borderleft column">
              <p
                v-if="tabela.ferramenta_patrimonio != null"
                style="width: 100%"
                class="text"
              >
                {{ tabela.ferramenta_patrimonio.toLowerCase() }}
              </p>
              <p v-else style="width: 100%" class="text">Sem Nº</p>
            </div>

            <div class="table3 borderleft column">
              <img
                v-if="
                  tabela.retirada_biometria != null &&
                  tabela.retirada_biometria != ''
                "
                style="width: 100%"
                class="biometria"
                :src="tabela.retirada_biometria"
                alt=""
              />

              <p v-else style="width: 100%" class="text"></p>
            </div>
            <div class="table4 borderleft column">
              <p
                v-if="
                  tabela.movimento_data_retirada != null &&
                  tabela.movimento_data_retirada != ''
                "
                style="width: 100%"
                class="text"
              >
                {{
                  tabela.movimento_data_retirada
                    .split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
              </p>
              <p v-else style="width: 100%" class="text">Sem data</p>
            </div>
            <div class="unidade-entrega column">
              <p
                v-if="
                  tabela?.movimento_unidade_entrega != null &&
                  tabela?.movimento_unidade_entrega != ''
                "
                style="width: 100%"
                class="text"
              >
                {{ tabela?.movimento_unidade_entrega }}
              </p>
              <p v-else style="width: 100%" class="text">Sem dados</p>
            </div>
          </div>
        </div>
        <div class="DEVOLUÇÃO">
          <div style="height: 100%" class="row">
            <div class="secondTable2 borderleft column">
              <img
                v-if="
                  tabela.entrega_biometria != null &&
                  tabela.entrega_biometria != ''
                "
                style="width: 100%"
                class="biometria"
                :src="tabela.entrega_biometria"
                alt=""
              />

              <p v-else style="width: 100%" class="text"></p>
            </div>
            <div class="secondTable3 borderleft column">
              <p
                v-if="
                  tabela.movimento_data_devolucao != null &&
                  tabela.movimento_data_devolucao != ''
                "
                style="width: 100%"
                class="text"
              >
                {{
                  tabela.movimento_data_devolucao
                    .split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
              </p>
              <p v-else style="width: 100%" class="text">Sem data</p>
            </div>
            <div class="unidade-devolucao column">
              <p
                v-if="
                  tabela?.movimento_unidade_devolucao != null &&
                  tabela?.movimento_unidade_devolucao != ''
                "
                style="width: 100%"
                class="text"
              >
                {{ tabela?.movimento_unidade_devolucao }}
              </p>
              <p v-else style="width: 100%" class="text">Sem dados</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { onMounted, ref, inject } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
export default {
  setup() {
    const $route = useRoute();

    const store = useStore();
    const dados = $route.params.nome;
    const tabelas = ref([]);
    const nome = ref("");
    const funcao = ref("");
    const registro = ref("");
    const keycloak = inject("keycloak");
    const realm = ref("");
    const quebras = ref([
      9, 22, 35, 48, 61, 74, 87, 100, 113, 126, 139, 152, 165, 178, 191,
    ]);
    const dadosFicha = ref({
      titulo: "",
      subtitulo: "",
      dizeres: "",
    });

    const getNome = async () => {
      realm.value = keycloak.realm;
      tabelas.value = await JSON.parse(dados);

      nome.value = await tabelas.value[0].usuario_nome;
      funcao.value = await tabelas.value[0].usuario_ghe;
      registro.value = await tabelas.value[0].usuario_matricula;

      store.dispatch("pdt/hiddenHeader", false);
    };

    const receberDadosFichaCautela = async () => {
      dadosFicha.value = {
        titulo: "",
        subtitulo: "",
        dizeres: "",
      };
      await store.state.org.unidadeData.id;
      try {
        const response = await store.dispatch("fer/receberDadosFichaCautela", {
          vendor_id: store.state.org.unidadeData.id,
        });
        if (response.data.result.data.length > 0) {
          dadosFicha.value = {
            titulo: response.data.result.data[0].titulo,
            subtitulo: response.data.result.data[0].subtitulo,
            dizeres: response.data.result.data[0].dizeres,
          };
        }
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(() => {
      getNome();
      receberDadosFichaCautela();
    });

    return {
      tabelas,
      nome,
      funcao,
      registro,
      realm,
      quebras,
      dadosFicha,
      receberDadosFichaCautela,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.base {
  border: 1px solid black;
}

.base p {
  margin: 0px;
}

.headerBase {
  border-bottom: 1px solid black;
  display: flex;
}

.border-botom {
  border-bottom: 1px solid black;
}

.separador {
  height: 5px;
  background-color: rgba(128, 128, 128, 0.541);
  border-bottom: 1px solid black;
}

.função {
  width: 65%;
}

.registro {
  width: 30%;
}

.data2 {
  border-top: 1px solid black;
}

.DESCRIÇÃODOMATERIAL {
  width: 35%;
}

.DESCRIÇÃODOMATERIAL p {
  height: 100%;
  align-items: center;
}

.ENTREGA {
  width: 35%;
}

.DEVOLUÇÃO {
  width: 30%;
}

.unidade-entrega {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.unidade-devolucao {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
}

.borderleft {
  border-right: 1px solid black;
}

.text {
  text-align: center;
}

.table1 {
  display: flex;
  justify-content: center;
  width: 25%;
  align-items: center;
}

.table3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.table4 {
  display: flex;
  justify-content: center;
  width: 25%;
  align-items: center;
}

.secondTable1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25%;
}

.secondTable2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 33%;
}

.secondTable3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
  margin: 0 auto;
}

.border-top {
  border-top: 1px solid black;
}

.headerBase p {
  width: 79%;
  display: flex;
  justify-content: center;
}

.biometria {
  padding: 6px;

  width: 50px !important;
}

.multpex {
  height: 50px;
  width: 130px;
}

.data3 {
  height: 76px;
}

.quebra {
  page-break-after: always;
}

.align {
  align-items: center;
}

@media print {
  p {
    font-size: 13px !important;
  }

  .biometria {
    padding: 4px;
    height: 70px;
    width: 50px !important;
  }
}
</style>
